import { DoorType } from "../../../entities-generated/common/door-type";
import { IProjectOverviewModel } from "../../../entities-generated/models/project/project-overview-model";
import { firstOrDefault } from "../../../framework/utils/collection";
import { toKebabCase } from "../../../framework/utils/string";

class ProjectOverviewServiceClass {
  public setOverview(overview: IProjectOverviewModel) {
    this.overview = overview;
  }

  public getOverview(projectId: string) {
    if(!this.overview) { return null; }
    if(projectId.toUpperCase() === this.overview.id.toUpperCase()) {
      return this.overview;
    }

    return null;
  }

  public getInstallationSite(name: string) {
    if(!this.overview) { return null; }
    const site = firstOrDefault(this.overview.workAreas, s => toKebabCase(s.name) === name);
    return site;
  }

  public getDoor(siteName: string, type: DoorType) {
    const site = this.getInstallationSite(siteName);
    if(!site) { return null; }
    const door = firstOrDefault(site.doorInstallations, d => d.doorType === type);
    return door;
  }

  private overview: IProjectOverviewModel | null = null;
}

export const ProjectOverviewService = new ProjectOverviewServiceClass();